var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewWindow = function SvgNewWindow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14 4.25a.75.75 0 0 0 0 1.5h4.19l-5.72 5.72a.75.75 0 1 0 1.06 1.06l5.72-5.72V11a.75.75 0 0 0 1.5 0V5a.75.75 0 0 0-.75-.75zm-9 1a.75.75 0 0 0-.75.75v14c0 .414.336.75.75.75h14a.75.75 0 0 0 .75-.75v-5a.75.75 0 0 0-1.5 0v4.25H5.75V6.75H10a.75.75 0 0 0 0-1.5z",
    clipRule: "evenodd"
  })));
};
export default SvgNewWindow;